import { NetworkStatusDialog } from '@client/components/_ui/feedback/connection-error';
import { useIsOffline } from '@client/hooks/system/useIsOffline';
import { useAppStateStore } from '@client/stores/AppStateStore';
import { categoriseNetworkError } from '@client/utils/errors/network-error-detection';
import { Modal } from 'antd';

/**
 * Displays an enhanced network status modal when the device goes offline
 * Uses the NetworkStatusDialog component for a rich, informative UI
 */
export function OfflineOverlay() {
    const isOffline = useIsOffline();
    const connectionState = useAppStateStore((state) => state.connectionState);

    // Create a mock error for the offline state to pass to our NetworkStatusDialog
    const offlineError = new Error('No internet connection detected');

    // Get detailed error information with connection state
    const errorDetails = categoriseNetworkError(
        offlineError,
        connectionState.quality,
        connectionState.consecutiveFailures,
    );

    const handleClose = () => {
        // User can't really close this modal while offline, but we could add logic here
        // For now, modal will auto-close when connection is restored (isOffline becomes false)
    };

    if (!isOffline) {
        return null;
    }

    return (
        <Modal
            open={isOffline}
            footer={null}
            closable={false}
            centered
            width={640}
            mask={{ closable: false }}
            keyboard={false}
        >
            <NetworkStatusDialog
                errorDetails={errorDetails}
                timestamp={new Date()}
                onClose={handleClose}
                endpoint={window.location.origin}
            />
        </Modal>
    );
}
